import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";

function extractUserId(input) {
  if (!input) return "";
  const trimmed = input.trim();
  // If it looks like a URL, try to pick `user=...`
  const m = trimmed.match(/[?&]user=([^&]+)/);
  if (m) return m[1];
  return trimmed;
}

export const SettingsDialog = ({ open, onOpenChange, currentUserId, onSave }) => {
  const [value, setValue] = useState(currentUserId || "");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setValue(currentUserId || "");
  }, [currentUserId, open]);

  const submit = async (e) => {
    e.preventDefault();
    const id = extractUserId(value);
    if (!id) return;
    setSaving(true);
    try {
      await onSave(id);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-lg bg-white border border-ink/15 rounded-none p-0"
        data-testid="settings-dialog"
      >
        <form onSubmit={submit}>
          <DialogHeader className="p-6 pb-3 border-b border-paper-edge">
            <div className="overline mb-2">Configuration</div>
            <DialogTitle className="font-display text-3xl tracking-tight">
              Scholar profile source
            </DialogTitle>
            <DialogDescription className="text-ink-mute">
              Paste a Google Scholar profile URL or just the user ID.
            </DialogDescription>
          </DialogHeader>
          <div className="p-6 space-y-3">
            <label className="overline" htmlFor="scholar-input">
              Profile URL or user ID
            </label>
            <input
              id="scholar-input"
              data-testid="settings-input"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="https://scholar.google.com/citations?user=majqS9gAAAAJ"
              className="w-full border border-paper-edge bg-paper-alt px-3 py-2.5 font-mono text-sm focus:outline-none focus:border-ink/40"
            />
            <p className="text-xs text-ink-mute font-mono">
              Resolved id:{" "}
              <span className="text-ink">{extractUserId(value) || "—"}</span>
            </p>
          </div>
          <DialogFooter className="px-6 pb-6 flex gap-2 sm:gap-3">
            <button
              type="button"
              onClick={() => onOpenChange(false)}
              className="btn-secondary text-xs"
              data-testid="settings-cancel"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving || !extractUserId(value)}
              className="btn-primary text-xs disabled:opacity-50"
              data-testid="settings-save"
            >
              {saving ? "Saving" : "Save & re-sync"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsDialog;
